import { render, staticRenderFns } from "./ScSaleCommodity.vue?vue&type=template&id=fb2b56f8&"
import script from "./ScSaleCommodity.vue?vue&type=script&lang=js&"
export * from "./ScSaleCommodity.vue?vue&type=script&lang=js&"
import style0 from "./ScSaleCommodity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports